import React from 'react';
import { WiDayStormShowers, WiAlien } from "react-icons/wi";
import { IoGlobeOutline } from "react-icons/io5";
import { MdDirectionsWalk, MdSmartToy } from "react-icons/md";

import { getUserDetails } from "../data/data";
import AppContent from '../shared/AppContent';
import { AuthContext } from "../../authContext";
import Loading from "../shared/Loading";
import PageHeading from '../shared/PageHeading';
import CategoryTitle from "../help/CategoryTitle";
import HelpResultCardContainer from "../help/HelpResultCardContainer";
import HelpResultCard from "../help/HelpResultCard";
import HelpResultIcon from "../help/HelpResultIcon";
import HelpArticleIcon from "../shared/utilities/HelpArticleIcon";
import Badge from "../shared/Badge";
import CategoryDisplayContainer from "../help/CategoryDisplayContainer";


class AnalysisModuleLibrary extends React.Component {
    static contextType = AuthContext;
    state = {
        isLoading: true,
        userDetails: {},
        isRunning: false,
        btnMessage: 'Run test',
        msg: '',
        receivedData: false,
        analysisData: {
            dwellings: '',
            latitude: '',
            longitude: '',
            output: ''
        }
    };
    componentDidMount = async () => {
        if (!this.context.isLoggedIn) {
            console.log("User login has expired, will redirect to homepage")
            this.context.navigate('/');
        }
        else {
            if (this.context.userDetails.token !== "") {
                const userDetails = await getUserDetails(this.context.userDetails.token);
                console.log("userDetails", userDetails)
                this.setState({userDetails: userDetails.data, isLoading: false});
            }
        }
    };

    render() {
        if (!this.context.isLoggedIn) {
            this.context.navigate('/');
            return "";
        }
        if (this.state.isLoading)
            return (<Loading />);
        else {
            return (
                <AppContent>
                    <PageHeading>Site Layout Toolkit</PageHeading>
                    <CategoryDisplayContainer gettingStarted={false}>
                        <CategoryTitle>{`Installed Modules`}</CategoryTitle>
                        <HelpResultCardContainer>
                            <HelpResultCard key={`urban-context`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis/urban-context`)}}>
                                <HelpResultIcon>
                                    <HelpArticleIcon reference={`earth2`} />
                                </HelpResultIcon>
                                <div>
                                    Urban Context
                                </div>
                            </HelpResultCard>
                        </HelpResultCardContainer>
                        <HelpResultCardContainer>
                            <HelpResultCard key={`analysemodel`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis/biodiversity-net-gain`)}}>
                                <HelpResultIcon>
                                    <HelpArticleIcon reference={`bird`} />
                                </HelpResultIcon>
                                <div>
                                    Biodiversity Net Gain <Badge bold>PROTOTYPE</Badge>
                                </div>
                            </HelpResultCard>
                        </HelpResultCardContainer>
                        <HelpResultCardContainer>
                            <HelpResultCard key={`environmental-analysis`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis/environmental-analysis`)}}>
                                <HelpResultIcon>
                                    <WiDayStormShowers size={32}/>
                                </HelpResultIcon>
                                <div>
                                    Solar Gain <Badge bold>PRIVATE</Badge>
                                </div>
                            </HelpResultCard>
                        </HelpResultCardContainer>
                        <HelpResultCardContainer>
                            <HelpResultCard key={`environmental-analysis`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis/environmental-analysis`)}}>
                                <HelpResultIcon>
                                    <WiAlien size={32}/>
                                </HelpResultIcon>
                                <div>
                                    Occupado <Badge bold>PRIVATE</Badge>
                                </div>
                            </HelpResultCard>
                        </HelpResultCardContainer>
                        <HelpResultCardContainer>
                            <HelpResultCard key={`environmental-analysis`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis/environmental-analysis`)}}>
                                <HelpResultIcon>
                                    <IoGlobeOutline size={32}/>
                                </HelpResultIcon>
                                <div>
                                    CFMS 2.0 PORTFOLIO <Badge bold>PRIVATE</Badge>
                                </div>
                            </HelpResultCard>
                        </HelpResultCardContainer>
                        <HelpResultCardContainer>
                            <HelpResultCard key={`environmental-analysis`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis/environmental-analysis`)}}>
                                <HelpResultIcon>
                                    <IoGlobeOutline size={32}/>
                                </HelpResultIcon>
                                <div>
                                    CFMS 2.0 RISK <Badge bold>PRIVATE</Badge>
                                </div>
                            </HelpResultCard>
                        </HelpResultCardContainer>
                        <HelpResultCardContainer>
                            <HelpResultCard key={`environmental-analysis`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis/environmental-analysis`)}}>
                                <HelpResultIcon>
                                    <MdDirectionsWalk size={32}/>
                                </HelpResultIcon>
                                <div>
                                    Streetscape <Badge bold>PRIVATE</Badge>
                                </div>
                            </HelpResultCard>
                        </HelpResultCardContainer>
                        <HelpResultCardContainer>
                            <HelpResultCard key={`environmental-analysis`} onClick={e => {e.preventDefault(); this.context.navigate(`./analysis/environmental-analysis`)}}>
                                <HelpResultIcon>
                                    <MdSmartToy size={32}/>
                                </HelpResultIcon>
                                <div>
                                    Project Cherwell <Badge bold>PRIVATE</Badge>
                                </div>
                            </HelpResultCard>
                        </HelpResultCardContainer>


                    </CategoryDisplayContainer>
                </AppContent>
            );
        }
    }
}

export default AnalysisModuleLibrary;